import { Component, Injector, Optional, Input } from '@angular/core';

import { ContactpersoonService } from 'src/app/core/service/contactpersoon.service';
import { Contactpersoon } from 'src/app/core/dto/contactpersoon';
import { Filter, FilterBuilder, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { Relatie } from 'src/app/core/dto/relatie';
import { MatSortable } from '@angular/material/sort';

@Component({
    selector: 'c-i-j-borculo-contactpersoon-collection',
    templateUrl: './contactpersoon-collection.component.html'/*,
    styleUrls: ['./contactpersoon-collection.component.css'] */
})
export class ContactpersoonCollectionComponent extends PagedCollectionComponent<Contactpersoon> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Contactpersoon>([
		{ colDef: 'naam', prop: x => x.naam, searchable: SearchableType.String },
		{ colDef: 'afdeling', prop: x => x.afdeling, searchable: SearchableType.String },
		{ colDef: 'functie', prop: x => x.functie, searchable: SearchableType.String },
		{ colDef: 'actief', prop: x => x.actief, searchable: SearchableType.Boolean }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: ContactpersoonService, @Optional() protected filter: Filter<Contactpersoon>, injector: Injector) {
        super('/contactpersoon/contactpersoon', injector, Contactpersoon);

		this.initInput('relatieID', this.filterBuilder.equal(x => x.relatieID.id));
	
    }

	ngOnInit() {
        super.ngOnInit();
        this.sort.sort(<MatSortable>{id: 'relatieID', start: 'asc'});
        this.sort.sort(<MatSortable>{id: 'naam', start: 'asc'});
		
        this.filter.onGetChipLabel(x => x.naam, () => 'Naam');
		this.filter.onGetChipLabel(x => x.afdeling, () => 'Afdeling');		
        this.filter.onGetChipLabel(x => x.functie, () => 'Functie');
		this.filter.onGetChipLabel(x => x.actief, () => 'Actief');
	}

	displayColumn(colDef: ColumnDefinition, ix: number) {
		// Hide columns that are already filtered on
		if(colDef.colDef == 'relatieID' && this.relatieID != null) { return false; }

		return super.displayColumn(colDef, ix);
	}

	@Input() set relatieID(val: Relatie) { this.handleInput('relatieID', val.id); }
}